import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import { Card, Typography, Box } from '@mui/material';

const RootStyle = styled(Card)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: theme.spacing(2, 2, 2, 3),
  height: '100%',
  cursor: 'pointer',
}));

const ContentCol = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(0.5),
  width: '100%',
}));

export default function MasterCard({ title, bgColor = 'white', titleOnTop = true, data = [] }) {
  return (
    <RootStyle sx={{ backgroundColor: bgColor }}>
      <ContentCol>
        {titleOnTop && (
          <Typography variant='h6' sx={{ color: 'text.secondary' }}>
            {title}
          </Typography>
        )}

        {Array.isArray(data) &&
          data.map((value, idx) => (
            <Typography
              key={value?.title ?? idx}
              variant='body2'
              component='p'
              sx={{
                color: 'text.secondary',
                display: 'block',
                whiteSpace: 'normal',
                wordBreak: 'break-word',
              }}
            >
              {value?.title} : {value?.value}
            </Typography>
          ))}
      </ContentCol>
    </RootStyle>
  );
}

MasterCard.propTypes = {
  title: PropTypes.string,
  bgColor: PropTypes.string,
  titleOnTop: PropTypes.bool,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.node,
      value: PropTypes.node,
    })
  ),
};
